import { useIntl } from 'react-intl'
import BaseTransportSummary from './BaseTransportSummary'

import type { TrainItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TrainItem
}

function TrainItemSummary(props: Props) {
  const intl = useIntl()
  return <BaseTransportSummary
    transportName={intl.formatMessage({
      id: 'R-l2ytNmFZEvf-vfGGAh',
      defaultMessage: 'Train',
      description: 'Transport type name for train used in trip item summary heading',
    })}
    {...props}
  />
}

export default TrainItemSummary
